import { render } from "./ViewerApp.vue?vue&type=template&id=d09639f4&scoped=true"
import script from "./ViewerApp.vue?vue&type=script&lang=js"
export * from "./ViewerApp.vue?vue&type=script&lang=js"

import "./ViewerApp.vue?vue&type=style&index=0&id=d09639f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d09639f4"]])

export default __exports__